import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Images from 'react-bootstrap/Image';

import {
    Table
    , Pagination
    , Loader
    , Button
    , IconButton
    , ButtonToolbar
    , Input
    , Tooltip
    , Whisper
    , Modal
    , VStack
    , HStack
    , SelectPicker
    , Toggle
    , DatePicker
    , Text
} from 'rsuite';

import Swal from 'sweetalert2'
import $ from 'jquery';

import moment from 'moment';

import Cropper from 'react-easy-crop'

export default class AnnouncementPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authHeader: { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } },
            content: null,
            modal: null,
            loading: false,
            data: [],
            sortColumn: '',
            sortType: '',
            loading: false,
            limit: 10,
            page: 1,
            status: false,
            default_year: '',
            year_name: '',
            start_date: '',
            end_date: '',
            announce: '',
            is_image: false,
            isImageChange: false,
            croppedImage: null,
            croppedArea: null,
            crop: { x: 0, y: 0 },
            zoom: 1,
            rotation: 0,
        };
    }

    async componentDidMount() {
        this.onRenderContent({ mode: 'read' })
    }

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            try {

                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true }); // Set loading state
                const statusResponse = await axios.get(`${process.env.REACT_APP_API}/status/1`, this.state.authHeader);
                const statusData = statusResponse.data;

                const status = statusData[0];

                const announceResponse = await axios.get(`${process.env.REACT_APP_API}/announce/1`, this.state.authHeader);
                const announceData = announceResponse.data[0];

                await this.promisedSetState({
                    announce: announceData.text,
                    is_image: announceData.is_image,
                    croppedImage: this.state.isImageChange ? this.state.croppedImage : `${process.env.REACT_APP_UPLOAD}/${announceData.path}`
                });

                const yearResponse = await axios.get(`${process.env.REACT_APP_API}/years`, this.state.authHeader);
                const yearData = yearResponse.data.map((res, index) => {
                    const thaiMonths = [
                        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
                        "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
                    ];

                    const formatToThaiDate = (dateString) => {
                        const date = new Date(dateString);
                        const day = date.getDate().toString().padStart(2, '0');
                        const month = thaiMonths[date.getMonth()];
                        const year = date.getFullYear() + 543;
                        return `${parseInt(day)} ${month} ${year}`;
                    };

                    return {
                        index: index + 1,
                        id: res.id,
                        name: res.year_name,
                        start_date: formatToThaiDate(res.start_date),
                        end_date: formatToThaiDate(res.end_date),
                        value: res.year_name,
                        label: res.year_name,
                    };
                });

                await this.promisedSetState({
                    data: yearData,
                    status: status.status,
                    default_year: status.default_year
                });

                const paginatedData = await this.getData();

                await this.promisedSetState({ content: null })
                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>เปิด-ปิดการรับสมัคร</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <Text weight='bold'>สถานะเปิด-ปิดการรับสมัครนักเรียนทุน</Text>
                            </Col>
                        </Row>

                        <Row className='mb-3' style={{ marginLeft: '0.5rem' }}>
                            <Col>
                                <HStack>
                                    <label>สถานะ</label>
                                    <Toggle
                                        checkedChildren="เปิด"
                                        unCheckedChildren="ปิด"
                                        defaultChecked={this.state.status}
                                        onChange={async (b, e) => {
                                            Swal.fire({
                                                title: "คุณต้องการเปลี่ยนสถานะใช่หรือไม่?",
                                                icon: "warning",
                                                showDenyButton: true,
                                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
                                            }).then(async (result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {

                                                    const Response = await axios.put(`${process.env.REACT_APP_API}/status`, {
                                                        status: b
                                                    }, this.state.authHeader);

                                                    const status = Response.data;

                                                    if (status.message === 'successfully') {

                                                        await this.onRenderContent({ mode: 'read' })

                                                        Swal.fire({
                                                            title: "ดำเนินการเรียบร้อยแล้ว",
                                                            icon: "success",
                                                            timer: 2000,
                                                            timerProgressBar: true,
                                                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                        });
                                                    }
                                                } else if (result.isDenied) {

                                                    await this.onRenderContent({ mode: 'read' })
                                                }
                                            });
                                        }}
                                    />
                                </HStack>
                            </Col>
                        </Row>

                        <Row className='mb-3' style={{ marginLeft: '0.5rem' }}>
                            <Col>
                                <HStack>
                                    <label>ปีที่รับสมัคร</label>
                                    <SelectPicker
                                        cleanable={false}
                                        data={this.state.data}
                                        searchable={false}
                                        defaultValue={this.state.default_year}
                                        style={{ width: 160 }}
                                        onChange={async e => {
                                            Swal.fire({
                                                title: "คุณต้องการแก้ไขปีที่รับสมัครใช่หรือไม่?",
                                                icon: "warning",
                                                showDenyButton: true,
                                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
                                            }).then(async (result) => {

                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                    const Response = await axios.put(`${process.env.REACT_APP_API}/default`, {
                                                        year: e
                                                    }, this.state.authHeader);

                                                    const data = Response.data;

                                                    if (data.message === 'successfully') {

                                                        await this.onRenderContent({ mode: 'read' })

                                                        Swal.fire({
                                                            title: "ดำเนินการเรียบร้อยแล้ว",
                                                            icon: "success",
                                                            timer: 2000,
                                                            timerProgressBar: true,
                                                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                        });
                                                    }
                                                } else if (result.isDenied) {

                                                    await this.onRenderContent({ mode: 'read' })
                                                }
                                            });
                                        }}
                                    />
                                </HStack>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <Button size='sm'
                                    startIcon={<i className="bi bi-plus-lg"></i>}
                                    color="green"
                                    appearance="primary"
                                    onClick={() => this.onModal({ mode: 'insert' })} >
                                    เพิ่ม
                                </Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Table
                                    autoHeight
                                    data={paginatedData}
                                    bordered
                                    cellBordered
                                    sortColumn={this.state.sortColumn}
                                    sortType={this.state.sortType}
                                    onSortColumn={async (sortColumn, sortType) => {
                                        await this.handleSortColumn(sortColumn, sortType);
                                    }}
                                    className='shadow-sm'
                                >
                                    <Column width={60} align="center">
                                        <HeaderCell>ลำดับ</HeaderCell>
                                        <Cell dataKey="index" />
                                    </Column>

                                    <Column width={215} sortable>
                                        <HeaderCell>ปีการศึกษา</HeaderCell>
                                        <Cell dataKey="name" />
                                    </Column>

                                    <Column width={460} sortable>
                                        <HeaderCell>เปิดตั้งแต่</HeaderCell>
                                        <Cell dataKey="start_date" />
                                    </Column>

                                    <Column width={460} sortable>
                                        <HeaderCell>สิ้นสุด</HeaderCell>
                                        <Cell dataKey="end_date" />
                                    </Column>

                                    <Column width={100} align='center' fixed="right">
                                        <HeaderCell>...</HeaderCell>

                                        <Cell style={{ padding: '6px' }}>
                                            {rowData => (
                                                <ButtonToolbar>
                                                    <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                        <IconButton size='sm'
                                                            color="yellow"
                                                            appearance="primary"
                                                            icon={<i className="bi bi-pencil-square"></i>}
                                                            onClick={() => this.onModal({ mode: 'update', id: rowData.id })}
                                                        />
                                                    </Whisper>
                                                    <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                        <IconButton size='sm'
                                                            color="red"
                                                            appearance="primary"
                                                            icon={<i className="bi bi-trash-fill"></i>}
                                                            onClick={() => this.onConfirm({ mode: 'delete', id: rowData.id })}
                                                        />
                                                    </Whisper>
                                                </ButtonToolbar>
                                            )}
                                        </Cell>
                                    </Column>
                                </Table>

                                <div style={{ padding: 20 }}>
                                    <Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '|', 'pager']}
                                        total={yearData.length}
                                        limit={this.state.limit}
                                        activePage={this.state.page}
                                        onChangePage={async (e) => {
                                            await this.promisedSetState({ page: e }); // Update current page
                                            await this.onRenderContent({ mode: 'read' }); // Fetch new data based on page
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <hr />

                        <Row className='mb-2'>
                            <Col>
                                <Text weight='bold'>ข้อความประกาศ</Text>
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <HStack spacing={'12px'}>
                                    <label>สถานะการใช้งานรูปภาพประกาศ</label>
                                    <Toggle className='mb-2'
                                        checkedChildren="ใช้งาน"
                                        unCheckedChildren="ไม่ใช้งาน"
                                        defaultChecked={this.state.is_image}
                                        onChange={e => this.setState({ is_image: e })}
                                    />
                                </HStack>
                                <Images
                                    className="border mb-2"
                                    src={this.state.croppedImage}
                                    rounded
                                    fluid
                                    width={1280}
                                    height={400} />
                                    <HStack>
                                <Button
                                    size='sm'
                                    color="green"
                                    appearance="subtle"
                                    startIcon={<i class="bi bi-card-image"></i>}
                                    onClick={() => this.onSelectedImage()}>กรุณาเลือกรูปภาพ</Button>
                                    <Text muted>(ขนาด 1,280 x 400 px)</Text>                       
                                    </HStack>
                                <input
                                    id='InputImageUpload'
                                    type='file'
                                    accept='image/*'
                                    onChange={(e) => this.onSelectFile({ event: e })}
                                    hidden />
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <VStack spacing={'6px'}>
                                    <Input as="textarea"
                                        rows={8}
                                        placeholder="กรุณากรอกข้อความ"
                                        defaultValue={this.state.announce}
                                        onChange={e => this.setState({ announce: e })}
                                    />
                                    <Text muted>หมายเหตุ: หากไม่ต้องการใช้งาน "ข้อความประกาศ" กรุณาลบข้อความทั้งหมด</Text>
                                    <Button
                                        size='sm'
                                        appearance='primary'
                                        color='blue'
                                        startIcon={<i className="bi bi-floppy"></i>}
                                        onClick={() => this.onConfirm({ mode: 'announce' })}
                                    >
                                        บันทึกประกาศ
                                    </Button>
                                </VStack>
                            </Col>
                        </Row>
                    </>
                });
            } catch (error) {
                console.error('API request failed:', error);
                // Consider adding user feedback here
            } finally {
                await this.promisedSetState({ loading: false }); // Reset loading state
            }
        }
    }

    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    handleSortColumn = async (sortColumn, sortType) => {
        await this.promisedSetState({ loading: true });

        await new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 500);
        });

        await this.promisedSetState({ loading: false });
        await this.promisedSetState({ sortColumn, sortType });

        // Call your onRenderContent function if needed
        await this.onRenderContent({ read: true });
    };

    getData = async () => {
        if (this.state.sortColumn && this.state.sortType) {
            return this.state.data.sort((a, b) => {
                let x = a[this.state.sortColumn];
                let y = b[this.state.sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (this.state.sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }

        return this.state.data.filter((v, i) => {
            const start = this.state.limit * (this.state.page - 1);
            const end = start + this.state.limit;
            return i >= start && i < end;
        });
    };

    onModal = async ({ mode, id }) => {
        if (mode === 'insert') {
            await this.promisedSetState({
                year_name: '',
                start_date: '',
                end_date: ''
            })

            await this.promisedSetState({
                modal: <Modal backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>เพิ่มปีการศึกษา</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>
                                            <HStack>
                                                <Text>ปีการศึกษา <span style={{ color: 'red' }}>*</span></Text>
                                                <Text muted>(ห้ามซ้ำ)</Text>
                                            </HStack>
                                        </label>
                                        <Input
                                            className='SiZmm'
                                            size='sm'
                                            onChange={e => this.setState({ year_name: e })} />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>เปิดตั้งแต่ <span style={{ color: 'red' }}>*</span></label>
                                        <DatePicker
                                            className='lBSDu'
                                            oneTap
                                            format="dd/MM/yyyy"
                                            block
                                            onChange={async (e) => {
                                                const localDate = moment(e).format('YYYY-MM-DD');
                                                await this.promisedSetState({ start_date: localDate });
                                            }}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>สิ้นสุด <span style={{ color: 'red' }}>*</span></label>
                                        <DatePicker
                                            className='P5mfX'
                                            oneTap
                                            format="dd/MM/yyyy"
                                            block
                                            onChange={async (e) => {
                                                const localDate = moment(e).format('YYYY-MM-DD');
                                                await this.promisedSetState({ end_date: localDate });
                                            }}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode: 'insert' })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        } else if (mode === 'update') {
            const { data } = await axios.get(`${process.env.REACT_APP_API}/years/${id}`, this.state.authHeader);
            const years = data[0];  // Assuming `data` is an array

            await this.promisedSetState({
                year_name: years.year_name,
                start_date: years.start_date,
                end_date: years.end_date
            })

            await this.promisedSetState({
                modal: <Modal backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>เพิ่มปีการศึกษา</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>
                                            <HStack>
                                                <Text>ปีการศึกษา <span style={{ color: 'red' }}>*</span></Text>
                                            </HStack>
                                        </label>
                                        <Input
                                            className='SiZmm'
                                            size='sm'
                                            value={this.state.year_name}
                                            readOnly
                                            onChange={e => this.setState({ year_name: e })} />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>เปิดตั้งแต่ <span style={{ color: 'red' }}>*</span></label>
                                        <DatePicker
                                            className='lBSDu'
                                            oneTap
                                            format="dd/MM/yyyy"
                                            block
                                            defaultValue={new Date(this.state.start_date)}
                                            onChange={async (e) => {
                                                const localDate = moment(e).format('YYYY-MM-DD');
                                                await this.promisedSetState({ start_date: localDate });
                                            }}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>สิ้นสุด <span style={{ color: 'red' }}>*</span></label>
                                        <DatePicker
                                            className='P5mfX'
                                            oneTap
                                            format="dd/MM/yyyy"
                                            block
                                            defaultValue={new Date(this.state.end_date)}
                                            onChange={async (e) => {
                                                const localDate = moment(e).format('YYYY-MM-DD');
                                                await this.promisedSetState({ end_date: localDate });
                                            }}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode: 'update', id: id })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        }
    }

    onSelectedImage = () => {
        const input = document.getElementById('InputImageUpload');
        if (input) {
            input.click(); // Trigger the file input click
        }
    }

    // Crop Image
    onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        this.setState({ croppedArea: croppedAreaPixels });
    };

    onSelectFile = async ({ event, mode, step }) => {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = async () => {
                await this.promisedSetState({ image: reader.result });
                await this.onImage({ mode: 'read', step })
            };
        }
    };

    createImage = (url) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = (error) => reject(error);
            image.crossOrigin = "anonymous"; // Handle cross-origin issues
            image.src = url;
        });
    };

    getRadianAngle(degreeValue) {
        return (degreeValue * Math.PI) / 180;
    }

    getBase64 = async (imageSrc, pixelCrop, rotation) => {
        const image = await this.createImage(imageSrc);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const maxSize = Math.max(image.width, image.height);
        const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

        canvas.width = safeArea;
        canvas.height = safeArea;

        ctx.translate(safeArea / 2, safeArea / 2);
        ctx.rotate(this.getRadianAngle(rotation));
        ctx.translate(-safeArea / 2, -safeArea / 2);

        ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);

        const data = ctx.getImageData(0, 0, safeArea, safeArea);

        // Adjust canvas to cropped area size
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.putImageData(
            data,
            0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x,
            0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y
        );

        return canvas.toDataURL("image/jpeg");
    };

    async base64ToBlob(base64String, contentType = '') {
        return new Promise((resolve, reject) => {
            try {
                const byteCharacters = atob(base64String);
                const byteArrays = [];

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArrays.push(byteCharacters.charCodeAt(i));
                }

                const byteArray = new Uint8Array(byteArrays);
                const blob = new Blob([byteArray], { type: contentType });

                resolve(blob); // Return the Blob as the result of the Promise
            } catch (error) {
                reject(error); // If any error occurs, reject the promise
            }
        });
    }

    onImage = async ({ mode, step }) => {
        if (mode === 'read') {
            await this.promisedSetState({
                modal: <Modal size='md' open={true} onClose={() => this.setState({ modal: null })}>
                    <Modal.Body>
                        <div style={{ width: '100%', height: '600px' }}>
                            <Cropper
                                image={this.state.image}
                                crop={this.state.crop}
                                zoom={this.state.zoom}
                                aspect={2.56}
                                onCropChange={async (e) => {
                                    await this.promisedSetState({ crop: e })
                                    await this.onImage({ mode, step })
                                }}
                                onZoomChange={async (e) => {
                                    await this.promisedSetState({ zoom: e })
                                    await this.onImage({ mode, step })
                                }}
                                onCropComplete={async (p, a) => {
                                    await this.promisedSetState({ croppedArea: a });
                                    await this.onImage({ mode, step })
                                }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className='p-2'>
                        <Button
                            onClick={async () => {
                                await this.promisedSetState({ loading: true }); // Set loading state to true
                                const croppedImage = await this.getBase64(this.state.image, this.state.croppedArea, 0);
                                await this.promisedSetState({ croppedImage, isImageChange: true, modal: null });
                                await this.onRenderContent({ mode: mode })
                                await this.promisedSetState({ loading: false }); // Reset loading state
                            }}
                            appearance="primary"
                            startIcon={<i className="bi bi-check2-square"></i>}>
                            ยืนยัน
                        </Button>
                        <Button
                            onClick={() => this.setState({ modal: null })}
                            appearance="subtle">
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            })
        }
    }

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params == cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params != cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onConfirm = async ({ mode, id }) => {

        const validate = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                this.Validate(this.state.year_name, 'SiZmm', ''),
                this.Validate(this.state.start_date, 'lBSDu', ''),
                this.Validate(this.state.end_date, 'P5mfX', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        if (mode === 'insert') {
            if (await validate()) {

                const Response = await axios.get(`${process.env.REACT_APP_API}/default/${this.state.year_name}`, this.state.authHeader);
                const count = Response.data.count

                if (count > 0) {
                    // Add 'required' class if condition is met
                    $('.SiZmm').addClass("required");

                    // Display an alert using SweetAlert
                    Swal.fire({
                        title: "ปีการศึกษาซ้ำ",
                        icon: "warning",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                } else {
                    $('.SiZmm').removeClass("required");
                }

                if (count === 0) {
                    const Response = await axios.post(`${process.env.REACT_APP_API}/years`, {
                        year_name: this.state.year_name,
                        start_date: this.state.start_date,
                        end_date: this.state.end_date
                    }, this.state.authHeader);

                    const years = Response.data;

                    if (years.message === 'successfully') {

                        await this.onRenderContent({ mode: 'read' })

                        await this.promisedSetState({ modal: null })

                        Swal.fire({
                            title: "คุณเพิ่มข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                }
            }
        } else if (mode === 'update') {
            if (await validate()) {
                const Response = await axios.put(`${process.env.REACT_APP_API}/years`, {
                    id: id,
                    start_date: this.state.start_date,
                    end_date: this.state.end_date
                }, this.state.authHeader);

                const years = Response.data;

                if (years.message === 'successfully') {

                    await this.onRenderContent({ mode: 'read' })

                    await this.promisedSetState({ modal: null })

                    Swal.fire({
                        title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
        } else if (mode === 'delete') {
            Swal.fire({
                title: "คุณต้องการลบใช่หรือไม่?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {

                    const Response = await axios.delete(`${process.env.REACT_APP_API}/years/${id}`, this.state.authHeader);

                    const ethnics = Response.data;

                    if (ethnics.message === 'successfully') {

                        await this.onRenderContent({ mode: 'read' })

                        Swal.fire({
                            title: "คุณลบข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                } else if (result.isDenied) {

                    await this.onRenderContent({ mode: 'read' })
                }
            });
        } else if (mode === 'announce') {

            await this.promisedSetState({ loading: true })

            // Create a new FormData object
            const formData = new FormData();

            // Append all form fields to FormData
            formData.append('id', 1);
            formData.append('text', this.state.announce);
            formData.append('is_image', this.state.is_image);

            const imageBlob = this.state.isImageChange
                ? await this.base64ToBlob(
                    this.state.croppedImage.split(',')[1],
                    this.state.croppedImage.split(';')[0].split(':')[1]
                )
                : await (await fetch(this.state.croppedImage)).blob();

            formData.append('image', imageBlob, 'image.png');

            const Response = await axios.put(`${process.env.REACT_APP_API}/announce`, formData, this.state.authHeader);

            const data = Response.data;

            if (data.message === 'successfully') {

                await this.onRenderContent({ mode: 'read' })

                await this.promisedSetState({ loading: false })

                Swal.fire({
                    title: "คุณแก้ไขประกาศเรียบร้อยแล้ว",
                    icon: "success",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
            }
        }
    }

    render() {
        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
